import { render, staticRenderFns } from "./SeminarsTable.vue?vue&type=template&id=d7430b0e&"
import script from "./SeminarsTable.vue?vue&type=script&lang=js&"
export * from "./SeminarsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports